import { Badge, Button, Dropdown, Input, Notification, Select, toast } from "components/ui";
import { CompanyContext } from "contexts/CompanyContext";
import { ModalContext } from "contexts/ModalContext";
import { TrendingNewsContext } from "contexts/TrendingNewsContext";
import React, { useContext, useEffect, useState } from "react";
import { HiCheckCircle, HiChevronDown, HiOutlineMagnifyingGlass } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { getReadableByURL } from "utils/getReadableByURL";
import { useTrendingNews } from "utils/hooks/useTrendingNews";
import TrendingNewsItem from "views/home/TrendingNewsItem";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { HiOutlineCheckCircle } from "react-icons/hi2";
import SocialNetworkSidePanel from "views/calendar/SocialNetworkSidePanel";
import GoogleTrendsApi from "services/GoogleTrendsApi";
import { formatNumber } from "utils/formatNumber";
import { api as Api } from "api/http";
import { replaceAll } from "utils/replaceAll";
import capitalize from "components/ui/utils/capitalize";
import { Table } from 'components/ui';
import { GiBroom } from "react-icons/gi";
import { CalendarActiveSocialNetworkContext } from "contexts/CalendarActiveSocialNetworkContext";
import { socialNetworkPrompts, socialNetworkPromptsSuffix } from "components/layout/MagicEditor/functions/AdaptToSocialNetwork";
import { components } from "react-select";
import { HiCheck } from "react-icons/hi";
import InputModern from "components/ui/Input/InputModern";
import { Loading } from "components/shared";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AIContext } from "contexts/AIContext";
import ConfigPanel from "../ConfigPanel";
import usePostGenerationQuantity from "utils/hooks/usePostGenerationQuantity";
import { useWhitelabel } from "contexts/WhitelabelThemeContext";

const { Tr, Th, Td, THead, TBody } = Table

const { Control } = components

const API_URL = process.env.REACT_APP_API_HOST;

const supportedLanguages = [
    {
        "language_country_code": "us",
        "language_code": "en",
        "language_name": "English"
    },
    {
        "language_country_code": "es",
        "language_code": "es",
        "language_name": "Spanish"
    },
    {
        "language_country_code": "de",
        "language_code": "de",
        "language_name": "German"
    },
    {
        "language_country_code": "br",
        "language_code": "pt",
        "language_name": "Portuguese"
    },
];

const supportedCountries = [
    {
      "country_code": "af",
      "country_name": "Afghanistan"
    },
    {
      "country_code": "al",
      "country_name": "Albania"
    },
    {
      "country_code": "dz",
      "country_name": "Algeria"
    },
    {
      "country_code": "as",
      "country_name": "American Samoa"
    },
    {
      "country_code": "ad",
      "country_name": "Andorra"
    },
    {
      "country_code": "ao",
      "country_name": "Angola"
    },
    {
      "country_code": "ai",
      "country_name": "Anguilla"
    },
    {
      "country_code": "aq",
      "country_name": "Antarctica"
    },
    {
      "country_code": "ag",
      "country_name": "Antigua and Barbuda"
    },
    {
      "country_code": "ar",
      "country_name": "Argentina"
    },
    {
      "country_code": "am",
      "country_name": "Armenia"
    },
    {
      "country_code": "aw",
      "country_name": "Aruba"
    },
    {
      "country_code": "au",
      "country_name": "Australia"
    },
    {
      "country_code": "at",
      "country_name": "Austria"
    },
    {
      "country_code": "az",
      "country_name": "Azerbaijan"
    },
    {
      "country_code": "bs",
      "country_name": "Bahamas"
    },
    {
      "country_code": "bh",
      "country_name": "Bahrain"
    },
    {
      "country_code": "bd",
      "country_name": "Bangladesh"
    },
    {
      "country_code": "bb",
      "country_name": "Barbados"
    },
    {
      "country_code": "by",
      "country_name": "Belarus"
    },
    {
      "country_code": "be",
      "country_name": "Belgium"
    },
    {
      "country_code": "bz",
      "country_name": "Belize"
    },
    {
      "country_code": "bj",
      "country_name": "Benin"
    },
    {
      "country_code": "bm",
      "country_name": "Bermuda"
    },
    {
      "country_code": "bt",
      "country_name": "Bhutan"
    },
    {
      "country_code": "bo",
      "country_name": "Bolivia"
    },
    {
      "country_code": "ba",
      "country_name": "Bosnia and Herzegovina"
    },
    {
      "country_code": "bw",
      "country_name": "Botswana"
    },
    {
      "country_code": "bv",
      "country_name": "Bouvet Island"
    },
    {
      "country_code": "br",
      "country_name": "Brazil"
    },
    {
      "country_code": "io",
      "country_name": "British Indian Ocean Territory"
    },
    {
      "country_code": "bn",
      "country_name": "Brunei Darussalam"
    },
    {
      "country_code": "bg",
      "country_name": "Bulgaria"
    },
    {
      "country_code": "bf",
      "country_name": "Burkina Faso"
    },
    {
      "country_code": "bi",
      "country_name": "Burundi"
    },
    {
      "country_code": "kh",
      "country_name": "Cambodia"
    },
    {
      "country_code": "cm",
      "country_name": "Cameroon"
    },
    {
      "country_code": "ca",
      "country_name": "Canada"
    },
    {
      "country_code": "cv",
      "country_name": "Cape Verde"
    },
    {
      "country_code": "ky",
      "country_name": "Cayman Islands"
    },
    {
      "country_code": "cf",
      "country_name": "Central African Republic"
    },
    {
      "country_code": "td",
      "country_name": "Chad"
    },
    {
      "country_code": "cl",
      "country_name": "Chile"
    },
    {
      "country_code": "cn",
      "country_name": "China"
    },
    {
      "country_code": "cx",
      "country_name": "Christmas Island"
    },
    {
      "country_code": "cc",
      "country_name": "Cocos (Keeling) Islands"
    },
    {
      "country_code": "co",
      "country_name": "Colombia"
    },
    {
      "country_code": "km",
      "country_name": "Comoros"
    },
    {
      "country_code": "cg",
      "country_name": "Congo"
    },
    {
      "country_code": "cd",
      "country_name": "Congo, the Democratic Republic of the"
    },
    {
      "country_code": "ck",
      "country_name": "Cook Islands"
    },
    {
      "country_code": "cr",
      "country_name": "Costa Rica"
    },
    {
      "country_code": "ci",
      "country_name": "Cote D'ivoire"
    },
    {
      "country_code": "hr",
      "country_name": "Croatia"
    },
    {
      "country_code": "cu",
      "country_name": "Cuba"
    },
    {
      "country_code": "cy",
      "country_name": "Cyprus"
    },
    {
      "country_code": "cz",
      "country_name": "Czech Republic"
    },
    {
      "country_code": "dk",
      "country_name": "Denmark"
    },
    {
      "country_code": "dj",
      "country_name": "Djibouti"
    },
    {
      "country_code": "dm",
      "country_name": "Dominica"
    },
    {
      "country_code": "do",
      "country_name": "Dominican Republic"
    },
    {
      "country_code": "ec",
      "country_name": "Ecuador"
    },
    {
      "country_code": "eg",
      "country_name": "Egypt"
    },
    {
      "country_code": "sv",
      "country_name": "El Salvador"
    },
    {
      "country_code": "gq",
      "country_name": "Equatorial Guinea"
    },
    {
      "country_code": "er",
      "country_name": "Eritrea"
    },
    {
      "country_code": "ee",
      "country_name": "Estonia"
    },
    {
      "country_code": "et",
      "country_name": "Ethiopia"
    },
    {
      "country_code": "fk",
      "country_name": "Falkland Islands (Malvinas)"
    },
    {
      "country_code": "fo",
      "country_name": "Faroe Islands"
    },
    {
      "country_code": "fj",
      "country_name": "Fiji"
    },
    {
      "country_code": "fi",
      "country_name": "Finland"
    },
    {
      "country_code": "fr",
      "country_name": "France"
    },
    {
      "country_code": "gf",
      "country_name": "French Guiana"
    },
    {
      "country_code": "pf",
      "country_name": "French Polynesia"
    },
    {
      "country_code": "tf",
      "country_name": "French Southern Territories"
    },
    {
      "country_code": "ga",
      "country_name": "Gabon"
    },
    {
      "country_code": "gm",
      "country_name": "Gambia"
    },
    {
      "country_code": "ge",
      "country_name": "Georgia"
    },
    {
      "country_code": "de",
      "country_name": "Germany"
    },
    {
      "country_code": "gh",
      "country_name": "Ghana"
    },
    {
      "country_code": "gi",
      "country_name": "Gibraltar"
    },
    {
      "country_code": "gr",
      "country_name": "Greece"
    },
    {
      "country_code": "gl",
      "country_name": "Greenland"
    },
    {
      "country_code": "gd",
      "country_name": "Grenada"
    },
    {
      "country_code": "gp",
      "country_name": "Guadeloupe"
    },
    {
      "country_code": "gu",
      "country_name": "Guam"
    },
    {
      "country_code": "gt",
      "country_name": "Guatemala"
    },
    {
      "country_code": "gn",
      "country_name": "Guinea"
    },
    {
      "country_code": "gw",
      "country_name": "Guinea-Bissau"
    },
    {
      "country_code": "gy",
      "country_name": "Guyana"
    },
    {
      "country_code": "ht",
      "country_name": "Haiti"
    },
    {
      "country_code": "hm",
      "country_name": "Heard Island and Mcdonald Islands"
    },
    {
      "country_code": "va",
      "country_name": "Holy See (Vatican City State)"
    },
    {
      "country_code": "hn",
      "country_name": "Honduras"
    },
    {
      "country_code": "hk",
      "country_name": "Hong Kong"
    },
    {
      "country_code": "hu",
      "country_name": "Hungary"
    },
    {
      "country_code": "is",
      "country_name": "Iceland"
    },
    {
      "country_code": "in",
      "country_name": "India"
    },
    {
      "country_code": "id",
      "country_name": "Indonesia"
    },
    {
      "country_code": "ir",
      "country_name": "Iran, Islamic Republic of"
    },
    {
      "country_code": "iq",
      "country_name": "Iraq"
    },
    {
      "country_code": "ie",
      "country_name": "Ireland"
    },
    {
      "country_code": "il",
      "country_name": "Israel"
    },
    {
      "country_code": "it",
      "country_name": "Italy"
    },
    {
      "country_code": "jm",
      "country_name": "Jamaica"
    },
    {
      "country_code": "jp",
      "country_name": "Japan"
    },
    {
      "country_code": "jo",
      "country_name": "Jordan"
    },
    {
      "country_code": "kz",
      "country_name": "Kazakhstan"
    },
    {
      "country_code": "ke",
      "country_name": "Kenya"
    },
    {
      "country_code": "ki",
      "country_name": "Kiribati"
    },
    {
      "country_code": "kp",
      "country_name": "Korea, Democratic People's Republic of"
    },
    {
      "country_code": "kr",
      "country_name": "Korea, Republic of"
    },
    {
      "country_code": "kw",
      "country_name": "Kuwait"
    },
    {
      "country_code": "kg",
      "country_name": "Kyrgyzstan"
    },
    {
      "country_code": "la",
      "country_name": "Lao People's Democratic Republic"
    },
    {
      "country_code": "lv",
      "country_name": "Latvia"
    },
    {
      "country_code": "lb",
      "country_name": "Lebanon"
    },
    {
      "country_code": "ls",
      "country_name": "Lesotho"
    },
    {
      "country_code": "lr",
      "country_name": "Liberia"
    },
    {
      "country_code": "ly",
      "country_name": "Libyan Arab Jamahiriya"
    },
    {
      "country_code": "li",
      "country_name": "Liechtenstein"
    },
    {
      "country_code": "lt",
      "country_name": "Lithuania"
    },
    {
      "country_code": "lu",
      "country_name": "Luxembourg"
    },
    {
      "country_code": "mo",
      "country_name": "Macao"
    },
    {
      "country_code": "mk",
      "country_name": "Macedonia, the Former Yugosalv Republic of"
    },
    {
      "country_code": "mg",
      "country_name": "Madagascar"
    },
    {
      "country_code": "mw",
      "country_name": "Malawi"
    },
    {
      "country_code": "my",
      "country_name": "Malaysia"
    },
    {
      "country_code": "mv",
      "country_name": "Maldives"
    },
    {
      "country_code": "ml",
      "country_name": "Mali"
    },
    {
      "country_code": "mt",
      "country_name": "Malta"
    },
    {
      "country_code": "mh",
      "country_name": "Marshall Islands"
    },
    {
      "country_code": "mq",
      "country_name": "Martinique"
    },
    {
      "country_code": "mr",
      "country_name": "Mauritania"
    },
    {
      "country_code": "mu",
      "country_name": "Mauritius"
    },
    {
      "country_code": "yt",
      "country_name": "Mayotte"
    },
    {
      "country_code": "mx",
      "country_name": "Mexico"
    },
    {
      "country_code": "fm",
      "country_name": "Micronesia, Federated States of"
    },
    {
      "country_code": "md",
      "country_name": "Moldova, Republic of"
    },
    {
      "country_code": "mc",
      "country_name": "Monaco"
    },
    {
      "country_code": "mn",
      "country_name": "Mongolia"
    },
    {
      "country_code": "ms",
      "country_name": "Montserrat"
    },
    {
      "country_code": "ma",
      "country_name": "Morocco"
    },
    {
      "country_code": "mz",
      "country_name": "Mozambique"
    },
    {
      "country_code": "mm",
      "country_name": "Myanmar"
    },
    {
      "country_code": "na",
      "country_name": "Namibia"
    },
    {
      "country_code": "nr",
      "country_name": "Nauru"
    },
    {
      "country_code": "np",
      "country_name": "Nepal"
    },
    {
      "country_code": "nl",
      "country_name": "Netherlands"
    },
    {
      "country_code": "an",
      "country_name": "Netherlands Antilles"
    },
    {
      "country_code": "nc",
      "country_name": "New Caledonia"
    },
    {
      "country_code": "nz",
      "country_name": "New Zealand"
    },
    {
      "country_code": "ni",
      "country_name": "Nicaragua"
    },
    {
      "country_code": "ne",
      "country_name": "Niger"
    },
    {
      "country_code": "ng",
      "country_name": "Nigeria"
    },
    {
      "country_code": "nu",
      "country_name": "Niue"
    },
    {
      "country_code": "nf",
      "country_name": "Norfolk Island"
    },
    {
      "country_code": "mp",
      "country_name": "Northern Mariana Islands"
    },
    {
      "country_code": "no",
      "country_name": "Norway"
    },
    {
      "country_code": "om",
      "country_name": "Oman"
    },
    {
      "country_code": "pk",
      "country_name": "Pakistan"
    },
    {
      "country_code": "pw",
      "country_name": "Palau"
    },
    {
      "country_code": "ps",
      "country_name": "Palestinian Territory, Occupied"
    },
    {
      "country_code": "pa",
      "country_name": "Panama"
    },
    {
      "country_code": "pg",
      "country_name": "Papua New Guinea"
    },
    {
      "country_code": "py",
      "country_name": "Paraguay"
    },
    {
      "country_code": "pe",
      "country_name": "Peru"
    },
    {
      "country_code": "ph",
      "country_name": "Philippines"
    },
    {
      "country_code": "pn",
      "country_name": "Pitcairn"
    },
    {
      "country_code": "pl",
      "country_name": "Poland"
    },
    {
      "country_code": "pt",
      "country_name": "Portugal"
    },
    {
      "country_code": "pr",
      "country_name": "Puerto Rico"
    },
    {
      "country_code": "qa",
      "country_name": "Qatar"
    },
    {
      "country_code": "re",
      "country_name": "Reunion"
    },
    {
      "country_code": "ro",
      "country_name": "Romania"
    },
    {
      "country_code": "ru",
      "country_name": "Russian Federation"
    },
    {
      "country_code": "rw",
      "country_name": "Rwanda"
    },
    {
      "country_code": "sh",
      "country_name": "Saint Helena"
    },
    {
      "country_code": "kn",
      "country_name": "Saint Kitts and Nevis"
    },
    {
      "country_code": "lc",
      "country_name": "Saint Lucia"
    },
    {
      "country_code": "pm",
      "country_name": "Saint Pierre and Miquelon"
    },
    {
      "country_code": "vc",
      "country_name": "Saint Vincent and the Grenadines"
    },
    {
      "country_code": "ws",
      "country_name": "Samoa"
    },
    {
      "country_code": "sm",
      "country_name": "San Marino"
    },
    {
      "country_code": "st",
      "country_name": "Sao Tome and Principe"
    },
    {
      "country_code": "sa",
      "country_name": "Saudi Arabia"
    },
    {
      "country_code": "sn",
      "country_name": "Senegal"
    },
    {
      "country_code": "rs",
      "country_name": "Serbia and Montenegro"
    },
    {
      "country_code": "sc",
      "country_name": "Seychelles"
    },
    {
      "country_code": "sl",
      "country_name": "Sierra Leone"
    },
    {
      "country_code": "sg",
      "country_name": "Singapore"
    },
    {
      "country_code": "sk",
      "country_name": "Slovakia"
    },
    {
      "country_code": "si",
      "country_name": "Slovenia"
    },
    {
      "country_code": "sb",
      "country_name": "Solomon Islands"
    },
    {
      "country_code": "so",
      "country_name": "Somalia"
    },
    {
      "country_code": "za",
      "country_name": "South Africa"
    },
    {
      "country_code": "gs",
      "country_name": "South Georgia and the South Sandwich Islands"
    },
    {
      "country_code": "es",
      "country_name": "Spain"
    },
    {
      "country_code": "lk",
      "country_name": "Sri Lanka"
    },
    {
      "country_code": "sd",
      "country_name": "Sudan"
    },
    {
      "country_code": "sr",
      "country_name": "Suriname"
    },
    {
      "country_code": "sj",
      "country_name": "Svalbard and Jan Mayen"
    },
    {
      "country_code": "sz",
      "country_name": "Swaziland"
    },
    {
      "country_code": "se",
      "country_name": "Sweden"
    },
    {
      "country_code": "ch",
      "country_name": "Switzerland"
    },
    {
      "country_code": "sy",
      "country_name": "Syrian Arab Republic"
    },
    {
      "country_code": "tw",
      "country_name": "Taiwan, Province of China"
    },
    {
      "country_code": "tj",
      "country_name": "Tajikistan"
    },
    {
      "country_code": "tz",
      "country_name": "Tanzania, United Republic of"
    },
    {
      "country_code": "th",
      "country_name": "Thailand"
    },
    {
      "country_code": "tl",
      "country_name": "Timor-Leste"
    },
    {
      "country_code": "tg",
      "country_name": "Togo"
    },
    {
      "country_code": "tk",
      "country_name": "Tokelau"
    },
    {
      "country_code": "to",
      "country_name": "Tonga"
    },
    {
      "country_code": "tt",
      "country_name": "Trinidad and Tobago"
    },
    {
      "country_code": "tn",
      "country_name": "Tunisia"
    },
    {
      "country_code": "tr",
      "country_name": "Turkey"
    },
    {
      "country_code": "tm",
      "country_name": "Turkmenistan"
    },
    {
      "country_code": "tc",
      "country_name": "Turks and Caicos Islands"
    },
    {
      "country_code": "tv",
      "country_name": "Tuvalu"
    },
    {
      "country_code": "ug",
      "country_name": "Uganda"
    },
    {
      "country_code": "ua",
      "country_name": "Ukraine"
    },
    {
      "country_code": "ae",
      "country_name": "United Arab Emirates"
    },
    {
      "country_code": "uk",
      "country_name": "United Kingdom"
    },
    {
      "country_code": "gb",
      "country_name": "United Kingdom"
    },
    {
      "country_code": "us",
      "country_name": "United States"
    },
    {
      "country_code": "um",
      "country_name": "United States Minor Outlying Islands"
    },
    {
      "country_code": "uy",
      "country_name": "Uruguay"
    },
    {
      "country_code": "uz",
      "country_name": "Uzbekistan"
    },
    {
      "country_code": "vu",
      "country_name": "Vanuatu"
    },
    {
      "country_code": "ve",
      "country_name": "Venezuela"
    },
    {
      "country_code": "vn",
      "country_name": "Viet Nam"
    },
    {
      "country_code": "vg",
      "country_name": "Virgin Islands, British"
    },
    {
      "country_code": "vi",
      "country_name": "Virgin Islands, U.S."
    },
    {
      "country_code": "wf",
      "country_name": "Wallis and Futuna"
    },
    {
      "country_code": "eh",
      "country_name": "Western Sahara"
    },
    {
      "country_code": "ye",
      "country_name": "Yemen"
    },
    {
      "country_code": "zm",
      "country_name": "Zambia"
    },
    {
      "country_code": "zw",
      "country_name": "Zimbabwe"
    }
];

const Item = ({item, isSelected, onSelect, onUnselect}) => {
    return (
        <div 
            onClick={isSelected ? onUnselect : onSelect} 
            className={`
                transition-all 
                bg-gray-50 
                hover:bg-gray-100 
                text-tertiary-700 
                dark:bg-gray-800 
                dark:text-gray-50 
                hover:dark:bg-gray-700 
                cursor-pointer 
                inline-block 
                p-3 
                px-4 
                rounded-2xl 
                !text-sm
                transition-all 
                flex
                items-center
                gap-2.5
                ${isSelected && `
                    border
                    border-primary-600
                    !bg-gray-50
                    dark:!bg-gray-800
                `}
            `}
        >
            <span className="flex-1">
                {item}
            </span>
            {isSelected 
                ? <HiCheckCircle className="shrink-0 text-2xl text-primary-600" />
                : <HiOutlineCheckCircle className="shrink-0 text-2xl opacity-[0.2]" />
            }
        </div>
    );
}


const CustomSelectOptionNotCircular = ({ innerProps, label, data, isSelected, test }) => {
    return (
        <div
            className={`flex items-center justify-between p-2 ${
                isSelected
                    ? 'bg-gray-100 dark:bg-gray-500'
                    : 'hover:bg-gray-50 dark:hover:bg-gray-600'
            }`}
            {...innerProps}
        >
            <div className="flex items-center">
                {data?.image && <img src={data?.image} className='rounded h-5 w-6' />}
                <span className="ml-2 rtl:mr-2">{data?.label ? data?.label : data?.value}</span>
            </div>
            {isSelected && <HiCheck className="text-emerald-500 text-xl" />}
        </div>
    )
}

const CustomControlNotCircular = ({ children, ...props }) => {
    const selected = props.getValue()[0]
    return (
        <Control {...props}>
            {selected && (
                <>
                    {selected?.image && <img src={selected.image} className='rounded h-5 w-6 ml-6' />}
                </>
            )}
            {children}
        </Control>
    )
}

const GoogleTemplate = ({
    generatePostsFromContexts,
    config,
    setConfig
}) => {

    const maxSelection = usePostGenerationQuantity();

    const { t } = useTranslation();
    const questions = {
      'en' : [
          {
              title: t(`googleTemplate.questions`),
              items: ["How {{term}} ", "Will {{term}} ", "When {{term}} ", "Why {{term}} ", "Where {{term}} ", "What {{term}} ", "Which {{term}} "]
          },
          {
              title: t(`googleTemplate.prepositions`),
              items: ["{{term}} to ", "{{term}} with ", "{{term}} near ", "{{term}} is ", "{{term}} can ", "{{term}} without ", "{{term}} for "]
          },
          {
              title: t(`googleTemplate.comparisons`),
              items: ["{{term}} and ", "{{term}} or ", "{{term}} like ", "{{term}} vs "]
          }
      ],
      'es' : [
          {
              title: t(`googleTemplate.questions`),
              items: ["Cómo {{term}} ", "{{term}} ", "Cuándo {{term}} ", "Por qué {{term}} ", "Dónde {{term}} ", "Qué {{term}} ", "Cuál {{term}} "]
          },
          {
              title: t(`googleTemplate.prepositions`),
              items: ["{{term}} a ", "{{term}} con ", "{{term}} cerca ", "{{term}} es ", "{{term}} puede ", "{{term}} sin ", "{{term}} para "]
          },
          {
              title: t(`googleTemplate.comparisons`),
              items: ["{{term}} y ", "{{term}} o ", "{{term}} como ", "{{term}} vs "]
          }
      ],
      'pt' : [
          {
              title: t(`googleTemplate.questions`),
              items: ["Como {{term}}", "{{term}}", "Quando {{term}}", "Por que {{term}}", "Onde {{term}}", "O que {{term}}", "Qual {{term}}"]
          },
          {
              title: t(`googleTemplate.prepositions`),
              items: ["{{term}} a", "{{term}} com", "{{term}} perto", "{{term}} é", "{{term}} pode", "{{term}} sem", "{{term}} para"]
          },
          {
              title: t(`googleTemplate.comparisons`),
              items: ["{{term}} e", "{{term}} ou", "{{term}} como", "{{term}} vs"]
          }
      ],
      'de': [
          {
            title: t(`googleTemplate.questions`),
            items: ["Wie {{term}} ", "{{term}} ", "Wann {{term}} ", "Warum {{term}} ", "Wo {{term}} ", "Was {{term}} ", "Welches {{term}} "]
          },
          {
            title: t(`googleTemplate.prepositions`),
            items: ["{{term}} zu ", "{{term}} mit ", "{{term}} in der Nähe von ", "{{term}} ist ", "{{term}} kann ", "{{term}} ohne ", "{{term}} für "]
          },
          {
            title: t(`googleTemplate.comparisons`),
            items: ["{{term}} und ", "{{term}} oder ", "{{term}} wie ", "{{term}} vs "]
          }
      ]
    }

    const { whitelabel } = useWhitelabel();
    const { calendarActiveSocialNetwork } = useContext(CalendarActiveSocialNetworkContext);
    const { company } = useContext(CompanyContext);
    const { closeModal } = useContext(ModalContext);
    const [ query, setQuery ] = useState("");
    const [ data, setData ] = useState();
    const [ suggestions, setSuggestions ] = useState([]);
    const [ selected, setSelected ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isLoadingSuggestions, setIsLoadingSuggestions ] = useState(false);
    const [ isLoadingReady, setIsLoadingReady ] = useState(false);
    const [ selectedCountryCode, setSelectedCountryCode ] = useState("us");
    const [ selectedLanguageCode, setSelectedLanguageCode ] = useState("en");
    const [ searchedTopic, setSearchedTopic ] = useState("");
    const locale = useSelector((state) => state.locale.currentLang);

    const countryOptions = supportedCountries.map((item) => {
        return { value: item.country_code, label: item.country_name, image: `https://flagcdn.com/h40/${item.country_code}.png` }
    });

    const languageOptions = supportedLanguages.map((item) => {
        return { value: item.language_code, label: item.language_name, language_country_code: item.language_country_code }
    });

    const getSuggestions = async () => {
        // setIsLoadingSuggestions(true);
        // let _suggestions = [];
        // let _interest = company?.interests[Math.floor(Math.random() * company?.interests?.length)];
        // Api.get(`/google/trends?method=relatedTopics&q=${_interest}`).then((response) => {
        //     setSuggestions([...new Set([...response?.data?.related_topics?.rising?.map(e => e?.topic?.title), ...response?.data?.related_topics?.top?.map(e => e?.topic?.title)])])
        // }).finally(() => {
        //     setIsLoadingSuggestions(false);
        // });
    }

    const get = async (newQuery = undefined) => {
        if (newQuery !== undefined) {
            setQuery(newQuery);
        } else {
            newQuery = query;
        }
        if (!newQuery) {
            toast.push(<Notification type="warning" title={`Write or select a topic to start`} />)
            return;
        }
        setData(undefined);
        setIsLoading(true);
        setSearchedTopic(newQuery);
        let _data = [];
        let _questions = selectedLanguageCode ? questions[selectedLanguageCode] : questions['en'];
        for (let questionObj of _questions) {
            _data.push({ 
                title: questionObj.title, 
                searches: [] 
            });
            for (let item of questionObj.items) {
                const searchStart = replaceAll(item, "{{term}}", newQuery);
                const url = `https://suggestqueries.google.com/complete/search?q=${searchStart}${selectedCountryCode && `&gl=${selectedCountryCode}`}${selectedLanguageCode && `&hl=${selectedLanguageCode}`}&client=firefox`;
                const autocomplete = await Api.get(`/proxy?url=${encodeURIComponent(url)}`, {}).then((responseText) => { return responseText; });
                if (autocomplete?.length > 1) {
                    let queriesArrays =  [autocomplete[1].splice(0, Math.ceil(autocomplete[1]?.length / 2)), autocomplete[1]];
                    let queries = [];
                    for (let _queries of queriesArrays) {
                        for (let _query of _queries) {
                            queries.push({ 
                                query: capitalize(_query), 
                                data: { total: 0 }
                            });
                        }
                    }
                    _data[_data?.length - 1]?.searches?.push({ search: capitalize(replaceAll(item, "{{term}}", "").trim()), queries: queries });
                }
            }
        }
        setData(_data);
        setIsLoading(false);
    }

    const onSelect = (item) => {
        if (selected?.length >= maxSelection) {
            toast.push(<Notification title={`You can't select more than ${maxSelection} queries at once.`} type="warning" />);
            return;
        }
        setSelected([item, ...selected]);
    }

    const onUnselect = (item) => {
        setSelected(selected.filter(e => e != item))
    }

    const handleOnSubmit = async () => {
      const contexts = selected;
      generatePostsFromContexts(contexts);
    }

    useEffect(() => {
      if (data) {
        localStorage.setItem(`googleTemplate${company?.id}`, JSON.stringify(data));
        localStorage.setItem(`googleTemplateQuery${company?.id}`, query);
        localStorage.setItem(`googleTemplateSearchedTopic${company?.id}`, searchedTopic);
        localStorage.setItem(`selectedCountryCode${company?.id}`, selectedCountryCode);
      }
    }, [data]);

    useEffect(() => {
      if (!data) {
        if (localStorage.getItem(`googleTemplate${company?.id}`)) {
          setData(JSON.parse(localStorage.getItem(`googleTemplate${company?.id}`)));
          setQuery(localStorage.getItem(`googleTemplateQuery${company?.id}`));
          setSearchedTopic(localStorage.getItem(`googleTemplateSearchedTopic${company?.id}`));
        }
      }
    }, []);

    useEffect(() => {
      if (!suggestions || !suggestions?.length) {
        if (localStorage.getItem(`googleTemplateSuggestions${company?.id}`)) {
          setSuggestions(JSON.parse(localStorage.getItem(`googleTemplateSuggestions${company?.id}`)));
        } else {
          getSuggestions();
        }
      }
    }, []);

    useEffect(() => {
      if (suggestions?.length > 0) {
        localStorage.setItem(`googleTemplateSuggestions${company?.id}`, JSON.stringify(suggestions));
      }
    }, [suggestions]);

    useEffect(() => {
      setSelectedLanguageCode(locale);
    }, [locale]);

    useEffect(() => {
      if (!data) {
        if (localStorage.getItem(`selectedCountryCode${company?.id}`)) {
          setSelectedCountryCode(localStorage.getItem(`selectedCountryCode${company?.id}`));
        }
      }
    }, []);
    
    return (
        <div className="w-full h-full flex items-start p-4 gap-4">
          <ConfigPanel 
              selected={selected}
              onSubmit={handleOnSubmit}
              config={config}
              setConfig={setConfig}
          />
          <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full h-full overflow-y-auto">
            <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full overflow-y-auto">
                <div className="overflow-y-auto p-1 shrink-0 flex-1 w-ful">
                  <div className="flex flex-col gap-2">
                    <div className="flex flex-col lg:flex-row items-center gap-2 w-full">
                        <Dropdown
                            placement="bottom-start"
                            parentClassName={`w-full flex-1 w-full`}
                            menuClass="w-auto max-h-[300px] overflow-y-auto"
                            renderTitle={
                                <Button className={`w-full flex gap-2 justify-between items-center !py-4 !px-6 !h-auto`}>
                                    <div className="flex items-center gap-2">
                                        <span className="!font-normal">Language:</span>
                                        <img className="h-3 w-4 object-fit object-cover" src={`https://flagcdn.com/h40/${languageOptions.find((option) => option.value === selectedLanguageCode).language_country_code}.png`} />
                                        {languageOptions.find((option) => option.value === selectedLanguageCode).label}
                                    </div>
                                    <HiChevronDown />
                                </Button>
                            }
                        >
                            {languageOptions.map((language, key) => (
                                <Dropdown.Item key={key} onClick={() => setSelectedLanguageCode(language.value)} className="flex items-center gap-2 py-2 px-4">
                                    <img className="h-3 w-4 object-fit object-cover" src={`https://flagcdn.com/h40/${language.language_country_code}.png`} />
                                    <span>{language.label}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown>
                        <Dropdown
                            placement="bottom-start"
                            parentClassName={`w-full flex-1 w-full`}
                            menuClass="w-auto max-h-[300px] overflow-y-auto"
                            renderTitle={
                                <Button className={`w-full flex gap-2 justify-between items-center !py-4 !px-6 !h-auto`}>
                                    <div className="flex items-center gap-2">
                                        <span className="!font-normal">Country:</span>
                                        <img className="h-3 w-4 object-fit object-cover" src={`https://flagcdn.com/h40/${countryOptions.find((option) => option.value === selectedCountryCode).value}.png`} />
                                        {countryOptions.find((option) => option.value === selectedCountryCode).label}
                                    </div>
                                    <HiChevronDown />
                                </Button>
                            }
                        >
                            {countryOptions.map((country, key) => (
                                <Dropdown.Item key={key} onClick={() => setSelectedCountryCode(country.value)} className="flex items-center gap-2 py-2 px-4">
                                    <img className="h-3 w-4 object-fit object-cover" src={`https://flagcdn.com/h40/${country.value}.png`} />
                                    <span>{country.label}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown>
                    </div>
                    <div className='relative bg-secondary-500 dark:bg-gray-700 rounded-2xl'> 
                      <InputModern 
                        fieldsetClassName="!bg-transparent"
                        className="!pl-8 !px-5 !py-5 !h-auto rounded-2xl !bg-transparent !font-semibold !text-slate-800 dark:!text-gray-100" 
                        value={query}
                        placeholder={t(`newsTemplate.placeholderQuery`)} 
                        prefix={<span className="!font-normal text-xs text-tertiary-600 dark:text-gray-300 mr-2 ml-2 !mb-3 !pb-0.5 inline-block">Topic: </span>}
                        onChange={(e) => setQuery(e.target.value)} 
                        onKeyUp={(e) => e.key == 'Enter' ? get() : void 0}
                      />
                      <Button 
                        loading={isLoading}
                        variant="twoTone" 
                        className="flex gap-2 items-center !absolute right-2.5 top-1/2 translate-y-[-50%]"
                        onClick={() => get()}
                        icon={<HiOutlineMagnifyingGlass />}
                      />
                    </div>
                    {!isLoading && suggestions?.length > 0 && <>
                        {/* <span className="text-xs p-1.5 px-2 whitespace-nowrap inline-block w-full text-left">Or select from {whitelabel?.name}'s trending topics suggestions:</span> */}
                        <div className={`flex flex-wrap w-full gap-2 max-h-[140px] overflow-y-auto`}>
                            {!isLoadingSuggestions && suggestions?.length > 0 &&
                                suggestions?.map((item) => (
                                  <Button className="!font-normal" size="xs" onClick={() => { get(item); }}>{item}</Button>
                                ))
                            }
                        </div>
                    </>}
                    <div className="h-fit pb-8">
                        {data && data?.length > 0 ? 
                            <div className="flex flex-col gap-6 mt-6">
                                {data?.map((category, key) => (
                                    <div className="flex flex-col gap-3" key={category?.title}>
                                        <h4 className="mega-title">{category?.title}</h4>
                                        <div className="flex flex-col gap-4">
                                            {!category?.searches?.filter(e => e?.queries?.length > 0)?.length && 
                                              <p className="font-semibold text-tertiary-300 dark:text-gray-700 text-base">No searches found for this category. Try another search topic, language or country.</p>
                                            }
                                            {category?.searches?.filter(e => e?.queries?.length > 0).map((search, subkey) => (
                                              <div className="bg-secondary-500 dark:bg-gray-800 rounded-2xl overflow-hidden">
                                                <Table key={search?.search}>
                                                    <THead>
                                                        <Tr>
                                                            <Th className="hidden lg:table-cell"></Th>
                                                            <Th className="uppercase text-left !font-bold lg:!pl-0">{search?.search}</Th>
                                                            <Th className="uppercase !text-right !font-normal !text-xs"></Th>
                                                        </Tr>
                                                    </THead>
                                                    <TBody>
                                                        {!search?.queries?.length && 
                                                          <p className="font-semibold text-tertiary-600">No queries found for this category. Try another search topic, language or country.</p>
                                                        }
                                                        {search?.queries?.sort((a,b) => b.data.total - a.data.total)?.map((query, index) => {
                                                            const isSelected = selected?.filter(e => e == query?.query)?.length > 0;
                                                            return (
                                                                <Tr key={query?.query} className={`cursor-pointer ${isSelected && `bg-primary-600/10`} ${key == 0 && subkey == 0 && index == 0 && `first-query`}`} onClick={() => { isSelected ? onUnselect(query?.query) : onSelect(query?.query) }}>
                                                                    <Td className="hidden lg:table-cell text-center !py-1.5 w-[10px] !px-0 font-semibold">
                                                                        {index == 0 && <span className="!text-xl !leading-[0px] block w-full text-center">🥇</span>}
                                                                        {index == 1 && <span className="!text-xl !leading-[0px] block w-full text-center">🥈</span>}
                                                                        {index == 2 && <span className="!text-xl !leading-[0px] block w-full text-center">🥉</span>}
                                                                        {/* {index >= 3 && `-`} */}
                                                                    </Td>
                                                                    <Td className="!py-1.5 lg:!pl-0 align-middle !text-gray-700 dark:!text-gray-300">
                                                                        <div className="h-3 w-3 rounded-full inline-block bg-primary-600 mr-4 -mb-[1.5px]" style={{ opacity: (search?.queries?.length - index) / search?.queries?.length }}></div>
                                                                        {capitalize(query?.query)}
                                                                    </Td>
                                                                    <Td className="!py-0 !pl-0 !align-middle !text-right">
                                                                        {!isSelected && <HiOutlineCheckCircle className="!text-xl opacity-[0.15] inline" />}
                                                                        {isSelected && <HiCheckCircle className="!text-xl inline text-primary-600" />}
                                                                    </Td>
                                                                </Tr>
                                                            );
                                                        })}
                                                    </TBody>
                                                </Table>
                                              </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        : isLoading && <div>
                            <div className="my-52"><Loading type={'element'} /></div>
                        </div>}
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default GoogleTemplate;